import { render, staticRenderFns } from "./SelectCompany.vue?vue&type=template&id=04e78a4f&"
import script from "./SelectCompany.vue?vue&type=script&lang=ts&"
export * from "./SelectCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports